import { useWindowWidth } from "./useWindowWidth"
import { theme } from "@oysterhr/theme"

const MD_SCREEN_SIZE = Number((theme.screens.md.match(/^\d+/) as [string])[0])

export function useIsMobile() {
  return useWindowWidth() < MD_SCREEN_SIZE
}
